// zustand store for geofences
import monitoringSlices, { type MonitoringSlices } from './slices';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const devtoolsInstance = devtools(monitoringSlices, {
  name: 'useMonitoringStore',
});

const useMonitoringStore = create<
  MonitoringSlices,
  [['zustand/devtools', never]]
>(devtoolsInstance);

export default useMonitoringStore;
